import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from '@/components/ui/provider';
import { Toaster } from '@/components/ui/toaster';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root niet gevonden');

createRoot(root).render(
  <StrictMode>
    <Provider>
      <App />
      {/* Buiten de router: meldingen via `toaster` blijven staan bij een navigatie. */}
      <Toaster />
    </Provider>
  </StrictMode>,
);
